/**
 * @file default-filter-modal.tsx
 * @description Универсальная форма фильтрации по умолчанию для модального окна фильтров в Task Manager приложении, которая обеспечивает динамическое отображение полей фильтрации на основе конфигурации. Поддерживает два режима отображения: обычный режим для основных фильтров и расширенный режим (isExtra) для настроек с фильтрацией по табу 'settings'. Использует утилиту getFieldByName для автоматической генерации полей формы по их типу и настройкам.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-09-18
 * @dependencies ['@features/filter/helper', '@features/filter/types', 'react-hook-form']
 * @related-files ['src/features/filter/components/table-modal/table-modal.component.tsx', 'src/features/filter/helper.ts']
 */

import { getFieldByName } from '@features/filter/helper';
import { filterComponent } from '@features/filter/types';
import { Control, FieldValues } from 'react-hook-form';

/**
 * Props для компонента DefaultFilterModalForm
 */
interface IDefaultFilterModalFormProps<TFieldValues extends FieldValues = FieldValues> {
    /** Control объект из react-hook-form для управления формой */
    control: Control<TFieldValues>;
    /** Массив фильтров для отображения */
    filters: filterComponent[];
    /** Режим отображения дополнительных настроек (settings) */
    isExtra?: boolean;
}

export const DefaultFilterModalForm = <TFieldValues extends FieldValues = FieldValues>({
    control,
    filters,
    isExtra
}: IDefaultFilterModalFormProps<TFieldValues>) => {
    if (isExtra) {
        return (
            <div className="flex flex-col gap-default w-[35.4611vmin]">
                {filters
                    .filter((filter: filterComponent) => filter.tab === 'settings')
                    .map((item: filterComponent, key: number) => getFieldByName(filters, control, item.name, { key }))}
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-default w-[35.4611vmin]">
            {filters
                .filter((filter: filterComponent) => filter.tab === 'filters')
                .map((item: filterComponent, key: number) => getFieldByName(filters, control, item.name, { key }))}
        </div>
    );
};